{
	"greeting": "Hi {name}",
	"greetingFirstTime": "Hi {name}. Let's start with your first material?",
	"firstSteps": {
		"title": "First steps",
		"progress": "{done} of {total}",
		"material": "Add your first material",
		"course": "Build a course",
		"topic": "Finish your first topic",
		"tutor": "Ask the tutor a question",
		"rhythm": "Set your study rhythm",
		"dismiss": "Hide",
		"collapse": "Collapse",
		"close": "Close",
		"reopen": "Next steps"
	},
	"summary": "Today: {dueCards, plural, one {# flashcard} other {# flashcards}} to review.",
	"kpi": {
		"streak": {
			"label": "review streak",
			"unit": "d",
			"start": "start"
		},
		"cards": {
			"label": "cards to review",
			"queueReady": "Queue ready",
			"queueReadyHint": "open the deck below",
			"queueEmptyHint": "no new reviews"
		},
		"mastery": {
			"label": "mastery this week",
			"trend": "week"
		},
		"today": {
			"label": "studied today",
			"unit": "min"
		}
	},
	"deck": {
		"title": "What to review today",
		"inQueueShort": "in queue",
		"refresh": "Refresh",
		"refreshing": {
			"title": "Refreshing recommendations",
			"subtitle": "Finding what to review today"
		},
		"next": "Next",
		"hide": "Hide",
		"position": "Card {current} of {total}",
		"positionEmpty": "queue empty",
		"emptyTitle": "Deck complete",
		"emptyBody": "Your review queue is empty — great work.",
		"emptyAfterSession": "{done} of {total} marked as done.",
		"emptyGenerate": "Generate new recommendations",
		"minutes": "{count} min",
		"kinds": {
			"cards": "Flashcards",
			"quiz": "Quiz",
			"weakSpot": "Weak spots",
			"note": "Note",
			"plan": "Study plan",
			"exam": "Exam",
			"streak": "Streak",
			"material": "Material",
			"review": "Review"
		},
		"actions": {
			"skip": "Postpone",
			"repeat": "Review",
			"done": "Done",
			"dismiss": "Dismiss recommendation",
			"skipTooltip": "Card moves to the end of the deck",
			"doneTooltip": "Mark as done"
		},
		"hint": "Swipe right — done · left — postpone · tap card — open review",
		"postponedChip": "Postponed",
		"swipeStamp": {
			"done": "Done",
			"skip": "Postpone"
		},
		"toast": {
			"done": "Done — card closed for today",
			"skip": "Postponed — card will return at the end of the deck",
			"dismiss": "Recommendation dismissed",
			"open": "Opening review…",
			"markActedFailed": "Could not mark as done — try again",
			"dismissFailed": "Could not dismiss — try again",
			"postponeFailed": "Could not save «postponed» — try again"
		}
	},
	"continue": {
		"title": "Continue",
		"viewAll": "All materials",
		"openedRecently": "Opened recently",
		"inCourse": "In course: {course}"
	},
	"empty": {
		"title": "Start with a course — or with your own material",
		"body": "We can build the course on a topic, take a ready-made one from the catalog, or assemble it from your files. A single material StudyHub breaks down into key ideas, cards and a quiz.",
		"course": "My courses",
		"upload": "Materials",
		"record": "Record lecture",
		"templates": "Course catalog"
	},
	"weekGoal": {
		"title": "Weekly goal",
		"caption": "{done} of {target} min",
		"sub": "to goal",
		"subEmpty": "nothing yet"
	},
	"queue": {
		"title": "In queue",
		"stat": "{count, plural, one {# task} other {# tasks}} · ~{minutes} min",
		"hint": "Mark them done to clear the queue. Start with the top card of the deck.",
		"hintEmpty": "Queue is empty — check back after new materials."
	},
	"activity": {
		"title": "Your rhythm",
		"less": "less",
		"more": "more",
		"noActivity": "no activity",
		"cellSummary": "{minutes} min"
	},
	"myCourses": {
		"title": "My courses",
		"all": "All courses",
		"showAll": "Show all",
		"showLess": "Show less"
	},
	"launcher": {
		"title": "Tools",
		"tutorChat": "Tutor chat",
		"tutorChatHint": "Ask about your material",
		"voiceTutor": "Voice tutor",
		"voiceTutorHint": "Talk through a topic",
		"audioRecap": "Audio recap",
		"audioRecapHint": "Listen instead of reading",
		"characters": "Learn with a character",
		"charactersHint": "Practice with a historical figure",
		"recordLecture": "Record lecture",
		"recordLectureHint": "Lecture becomes notes",
		"upload": "Upload material",
		"uploadHint": "PDF, lecture, notes",
		"discover": "Internet research",
		"discoverHint": "Find sources and save to library",
		"quizzes": "Tests",
		"quizzesHint": "Check yourself with a quiz",
		"essay": "Essay grading",
		"essayHint": "Review with edits",
		"visuals": "Explain a photo",
		"visualsHint": "Chart, problem, formula",
		"glossary": "Glossary",
		"glossaryHint": "Terms from your materials",
		"flashcards": "Flashcards",
		"flashcardsHint": "Memorize with spaced repetition"
	},
	"brief": {
		"title": "Daily tip",
		"refresh": "Refresh tips",
		"refreshing": "Picking tips",
		"emptyTitle": "Nothing yet",
		"emptyBody": "Tips will appear once you build up activity.",
		"goalOfDay": "Today's goal",
		"termOfDay": "Term of the day",
		"studyTip": "Tip",
		"didYouKnow": "Did you know",
		"milestone": "Milestone",
		"microCheck": "Check yourself",
		"revealAnswer": "Show answer",
		"practice": "Practice",
		"open": "Open",
		"prev": "Previous",
		"next": "Next",
		"expand": "Expand",
		"collapse": "Collapse",
		"goalMinutes": "{done} / {goal} min"
	},
	"catalogHighlights": {
		"title": "Course catalog",
		"allCourses": "All courses",
		"scrollPrev": "Previous courses",
		"scrollNext": "Next courses"
	}
}
